import { Component } from '@angular/core';
import { Subject } from 'rxjs';
import { SubMenu, TipoRevision, Revisiones, RevisionUpdateChild } from 'src/app/types/type';
import { Utilerias } from 'src/app/helpers/Utilerias';
import { PlaneacionService } from 'src/app/services/planeacion.service';
import { Negocios } from 'src/app/types/Entitys';
import { MasterDB } from 'src/app/DAO/MasterDB';
import { EstacionesTVADB } from 'src/app/DAO/EstacionesTVADB';
import { UsuariosService } from 'src/app/services/usuarios.service';
declare var $: any;

@Component({
  selector: 'app-planeacion',
  templateUrl: './planeacion.component.html',
  styleUrls: ['./planeacion.component.css']
})
export class PlaneacionComponent {
  subMenus: SubMenu[];
  title: string;
  collectionRevisiones: Revisiones[];
  tipoRevisiones: any;
  negocios: Negocios[];
  objetivo: string;
  alcance: string;
  revisionId: number;
  dtTrigger: Subject<any> = new Subject<any>();
  showContent: boolean;
  disableBtnNewRevision = true;
  page: number = 2;
  loadRows = false;
  IdEmpleado: number;

  constructor(private revisionServicio: PlaneacionService, private userService: UsuariosService) {
    this.title = 'Configuracion de revisiones';
    this.showContent = false;
  }

  async ngOnInit() {
    this.Inicializar();    
  }

  ngOnDestroy() {
    this.dtTrigger.unsubscribe();
  }

  async Inicializar() {    
    this.loadSubMenu();
    this.IdEmpleado = (await this.userService.getUsuario()).IdEmpleado;
    this.revisionServicio.fetchLoadInit(this.IdEmpleado)
      .subscribe(([revisiones, negocios, tipoRevisiones]) => {
        if (revisiones.Result.Exito && negocios.Result.Exito && tipoRevisiones.Result.Exito) {
          this.collectionRevisiones = revisiones.Result.Data as Revisiones[]
          this.tipoRevisiones = tipoRevisiones.Result.Data as TipoRevision[]
          this.negocios = negocios.Result.Data as Negocios[]

          this.showContent = true
          this.disableBtnNewRevision = false
        }
      });
  }

  editObjetivoClick(id: number, objetivo: string, alcance: string) {
    this.revisionId = id;
    this.alcance = alcance;
    this.objetivo = objetivo;
    $('#modalEditObjetivo').modal('show');
  }

  eliminarRevision(idRevision: number) {
    Utilerias.alertConfirm('¿Deseas eliminar la revisión?')
      .then(res => {
        if (res.value) {
          this.revisionServicio.eliminarRevision(idRevision)
            .subscribe(response => {
              if (response?.Result?.Exito) {
                this.collectionRevisiones = this.collectionRevisiones.filter(x => x.IdRevision != idRevision);
              }
            })
        }
      });
  }

  loadSubMenu() {
    this.subMenus = [{
      active: true,
      child: false,
      label: 'Revisiones',
      class: 'submenu__item submenu--active d-flex align-items-center'
    }];
  }

  datetimeToDateFormat(input: string) {
    return Utilerias.datetimeToDateFormat(input);
  }

  saveRevisionChild(revision: Revisiones) {
    this.disableBtnNewRevision = true
    this.revisionServicio.getTipoRevisiones()
      .subscribe((response) => {
        if (response?.Result?.Exito) {
          this.collectionRevisiones.unshift(revision)
          this.tipoRevisiones = response.Result.Data as TipoRevision[]
          this.disableBtnNewRevision = false
        } else
          Utilerias.alertClient('', response?.Result?.Error, 1);
      })
  }

  revisionUpdateChild(revision: RevisionUpdateChild) {    
    const index = this.collectionRevisiones.findIndex(r => r.IdRevision === revision.idRevision)
    this.collectionRevisiones[index].alcance = revision.alcance
    this.collectionRevisiones[index].objetivo = revision.objetivo
  }

  loadRevisiones() {
    this.loadRows = true;
    this.revisionServicio.getRevisiones(this.IdEmpleado, this.page++)
      .subscribe(response => {
        if (response.Result.Exito) {
          const revisiones = response.Result.Data as Revisiones[]
          this.collectionRevisiones = [...this.collectionRevisiones, ...revisiones]
          this.loadRows = false;
          if (revisiones.length === 0)
            this.page--
        }
      })
  }
}
